module.exports = new __parcel__URL__("counter.eda3307e.webp").toString();